import { globalReactService } from '@commons'

export const urlBase = globalReactService.lmsApi

export const api = {
  userInformation: `${urlBase}/users/by_token`,
  myCourses: `${urlBase}/users/{userId}/unified_courses`,
  myCertificates: `${urlBase}/users/{userId}/unified_certificates`
}
